import { MotionEditorPage } from '../components/ProductPages';
import { publicMeta } from './public-meta';

export const meta = publicMeta(
  'Performance Editor | Cartwheel',
  'Performance Editor uses Swing to direct and modify motion through poses and paths, then regenerates the performance to match.',
);

export default MotionEditorPage;
